// extracted by mini-css-extract-plugin
module.exports = {"done":"status-component_done__1A586"};